// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-list-item--dense[data-v-53610db1],\n.v-list--dense .v-list-item[data-v-53610db1] {\n    min-height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
